import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaultType, setDefaultType] = useState("booking");

  const openBooking = (type = "booking") => {
    setDefaultType(type);
    setOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, openBooking, defaultType }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
